/**
 * Terminal: SSH shells for the vault's `sftp` connections plus local shells
 * (the surface the Dev Tools footer terminal moved into). HOST-RENDERED
 * (TerminalExtSidebar.js + TerminalExtView.js) — SSH sessions are opened by
 * vault item id and the credentials are resolved INSIDE Rust (ssh_term.rs +
 * vault::ssh_credentials_for_item), so secrets never enter the webview. That
 * is what makes the AI terminal tools safe: the model can run commands on a
 * server without any code path that could hand it vault secrets. The guest
 * entry.js is a no-op kept only to satisfy the registration contract.
 */
export const terminalManifest = {
  schemaVersion: 1,
  id: 'com.apiboo.terminal',
  name: 'Terminal',
  version: '0.1.0',
  publisher: 'apiboo',
  entry: 'dist/main.js',
  icon: 'terminal',
  engines: { apibooSdk: '^1.0.0' },
  // HOST-RENDERED, not sandboxed: the panel above is a first-party React
  // component calling Tauri directly, so `permissions: []` means "declares no
  // GUEST capabilities", not "has no access". Settings reads this flag to say
  // that plainly instead of showing an empty permission list that implies a
  // control the user does not have — see EXT-05.
  hostRendered: true,
  permissions: [],
  contributes: {
    activityBar: [
      {
        id: 'terminal.activity',
        title: 'Terminal',
        icon: 'terminal',
        order: { after: 'ftp.activity' },
      },
    ],
    panels: [{ id: 'terminal.panel', activityBarId: 'terminal.activity', title: 'Terminal' }],
    settings: [],
  },
};
